export default "__VITE_ASSET__CPJRhK3U__"